
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface Country {
  code: string;
  name: string;
}

export interface Constituency {
  code: string;
  name: string;
  country_code: string;
}

export const useCountries = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const { data, error } = await supabase
          .from("countries")
          .select("code, name")
          .eq("active", true)
          .order("name");
        if (error) throw error;
        setCountries(data || []);
      } catch (error: any) {
        console.error("Error fetching countries:", error.message);
      }
    };
    fetchCountries();
  }, []);
  return { countries };
};

export const useConstituencies = (countryCode: string | null | undefined) => {
  const [constituencies, setConstituencies] = useState<Constituency[]>([]);
  useEffect(() => {
    if (!countryCode) {
      setConstituencies([]);
      return;
    }
    const fetchConstituencies = async () => {
      try {
        const { data, error } = await supabase
          .from("constituencies")
          .select("code, name, country_code")
          .eq("country_code", countryCode)
          .eq("active", true)
          .order("name");
        if (error) throw error;
        setConstituencies(data || []);
      } catch (error: any) {
        setConstituencies([]);
      }
    };
    fetchConstituencies();
  }, [countryCode]);
  return { constituencies };
};
